import React from 'react';
import { Link } from 'react-router-dom';
import { Play, Download, FileText } from 'lucide-react';

const ResourceCard = ({ resource }) => {
  const hasAudio = resource.mp3_url;
  const hasPdf = resource.pdf_url;
  const hasVideo = resource.youtube_url || resource.video_url;

  return (
    <div 
      className="bg-white border border-slate-200 rounded shadow-sm hover:shadow-md hover:-translate-y-1 transition-all duration-300 overflow-hidden group"
      data-testid={`resource-card-${resource.id}`}
    >
      {/* Thumbnail */}
      <div className="relative h-48 bg-gradient-to-br from-brand-primary to-slate-700 overflow-hidden">
        {resource.thumbnail_url ? (
          <img 
            src={`${process.env.REACT_APP_BACKEND_URL}${resource.thumbnail_url}`} 
            alt={resource.title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center">
            <FileText className="h-16 w-16 text-brand-accent opacity-50" />
          </div>
        )}
        
        {/* Category Badge */}
        <div className="absolute top-3 right-3">
          <span className="bg-brand-primary/90 text-brand-accent border border-brand-accent/20 rounded-full px-3 py-1 text-xs font-medium uppercase tracking-wider backdrop-blur-sm">
            {resource.category}
          </span>
        </div>
      </div>

      {/* Content */}
      <div className="p-6">
        <h3 className="font-heading font-medium text-xl text-brand-primary mb-3 line-clamp-2">
          {resource.title}
        </h3>
        <p className="font-body text-base leading-relaxed text-slate-700 mb-4 line-clamp-3">
          {resource.description}
        </p>

        {/* Tags */}
        {resource.tags && resource.tags.length > 0 && (
          <div className="flex flex-wrap gap-2 mb-4">
            {resource.tags.slice(0, 3).map((tag, idx) => (
              <span key={idx} className="text-xs font-body text-slate-600 bg-slate-100 px-2 py-1 rounded">
                {tag}
              </span>
            ))}
          </div>
        )}

        {/* Action Buttons */}
        <div className="flex items-center justify-between mt-6 pt-4 border-t border-slate-100">
          <div className="flex space-x-2">
            {hasAudio && (
              <span className="flex items-center space-x-1 text-xs text-slate-600">
                <Play className="h-3 w-3" />
                <span>Audio</span>
              </span>
            )}
            {hasPdf && (
              <span className="flex items-center space-x-1 text-xs text-slate-600">
                <FileText className="h-3 w-3" />
                <span>PDF</span>
              </span>
            )}
            {hasVideo && (
              <span className="flex items-center space-x-1 text-xs text-slate-600">
                <Play className="h-3 w-3" />
                <span>Video</span>
              </span>
            )}
          </div>
          <Link
            to={`/resource/${resource.id}`}
            className="font-body text-sm font-medium text-brand-accent hover:text-brand-accent-hover transition-colors duration-300"
            data-testid={`view-resource-${resource.id}`}
          >
            View Resource →
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ResourceCard;